import { render, staticRenderFns } from "./TheGame.vue?vue&type=template&id=69d18184&"
import script from "./TheGame.vue?vue&type=script&lang=js&"
export * from "./TheGame.vue?vue&type=script&lang=js&"
import style0 from "./TheGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports